import { Building, Search, Stethoscope, UserRound, UserRoundIcon, UsersRound, X } from "lucide-react";
import { Input } from "../../ui/input";
import { Button } from "../../ui/button";

import Select from "react-select";

import { Badge } from "../../ui/badge";
import { ClinicScheduleStatusDto, DoctorDto } from "@/src/web-api-client";
import { SelectWithSearch } from "../../ui/SelectWithSearch";
import { mapDoctorsToOptions } from "../../../utils/map";

interface FilterToolbarProps {
  selectedDoctor: string;
  selectedRoom: string;
  onDoctorChange: (doctorId: string) => void;
  onRoomChange: (roomId: string) => void;
  onDoctorSearchChange: (query: string) => void;
  onClearFilters: () => void;
  doctorOptions: any;
  clinicOptions: any;
  isDoctorLoading?: boolean;
}

export default function FilterToolbar({
  selectedDoctor,
  selectedRoom,
  onDoctorChange,
  onRoomChange,
  onDoctorSearchChange,
  onClearFilters,
  doctorOptions,
  clinicOptions,
  isDoctorLoading,
}: FilterToolbarProps) {
  return (
    <div className="border-b bg-card px-3 sm:px-4 lg:px-6 py-3">
      <div className="flex flex-col gap-2 md:flex-row md:items-center md:gap-3">
        <div className="grid grid-cols-2 gap-2 md:flex md:items-center md:gap-3 md:w-auto">
          <div className="relative flex">
            <div className="absolute top-1/2 left-2 z-10 -translate-y-1/2 flex items-center justify-center gap-2">
              <UserRound className="text-primary w-5 h-auto" />
              <span className="text-sm font-bold leading-none">Bác sĩ: </span>
            </div>

            <SelectWithSearch<string>
              options={doctorOptions}
              selectedValue={selectedDoctor === "all" ? null : selectedDoctor}
              onChange={(value) => onDoctorChange(value ?? "all")}
              onInputChange={onDoctorSearchChange}
              placeholder="Tìm và chọn bác sĩ"
              className="w-full w-[25rem]"
              inputClassName="pl-[5rem]"
              isLoading={isDoctorLoading}
            />
          </div>

          <div className="relative flex">
            <div className="absolute top-1/2 left-2 z-10 -translate-y-1/2 flex items-center justify-center gap-2">
              <Stethoscope className="text-primary w-5 h-auto" />
              <span className="text-sm font-bold leading-none">Phòng khám: </span>
            </div>

            <SelectWithSearch<number>
              options={clinicOptions}
              selectedValue={selectedRoom === "all" ? null : Number(selectedRoom)}
              onChange={(value) => onRoomChange(value ? String(value) : "all")}
              placeholder="Lọc theo phòng"
              className="w-[30rem]"
              inputClassName="pl-[7.5rem]"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
